import _upperFirst from "lodash/upperFirst";
import i18n from '@signavio/i18n';
import invariant from 'invariant';
import { addMinutes, subMinutes, isToday, isAfter, formatDistanceToNowStrict, formatDistanceStrict } from 'date-fns';
import { getDateFnsLocale } from '../extensions/date-fns';
export function getDueMessage(date) {
  if (!date) {
    return;
  }
  const dueDate = new Date(date);
  const interpolations = {
    fromNow: formatDistanceToNowStrict(dueDate, {
      locale: getDateFnsLocale()
    })
  };
  if (isToday(dueDate)) {
    return i18n('Due today');
  }
  return _upperFirst(isAfter(dueDate, new Date()) ? i18n('Due in __fromNow__', interpolations) : i18n('__fromNow__ overdue', interpolations));
}
export function currentTimezone() {
  invariant(window.Intl, 'Expected `window.Intl` to be defined in the browser');
  return window.Intl.DateTimeFormat().resolvedOptions().timeZone;
}
export function getDurationHumanized(date, anotherDate) {
  return formatDistanceStrict(new Date(date), new Date(anotherDate), {
    locale: getDateFnsLocale()
  });
}

/**
 * Convert given date to UTC
 * @link https://github.com/date-fns/date-fns/issues/556#issuecomment-391048347
 * @param date | plain JS date object
 * @return {Date | *}
 */
export function toUTC(date) {
  const offset = date.getTimezoneOffset();
  return Math.sign(offset) !== -1 ? addMinutes(date, offset) : subMinutes(date, Math.abs(offset));
}